import React from 'react';
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline'
import { XMarkIcon } from '@heroicons/react/20/solid'

export default function Alert(props: {
  type: "success"|"error",
  title?: string;
  message: string;
  onClose?: () => void;
}) {
  let title = props.title;
  let message = props.message;
  if (!title) {
    title = message;
    message = '';
  }
  return (
    <div className="pointer-events-auto overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
      <div className="p-4">
    <div className="flex items-start">
      <div className="flex-shrink-0">
        {props.type === 'success' && <CheckCircleIcon aria-hidden="true" className="h-6 w-6 text-green-400" />}
        {props.type === 'error' && <ExclamationCircleIcon aria-hidden="true" className="h-6 w-6 text-red-400" />}
      </div>
      <div className="ml-3 w-0 flex-1 pt-0.5">
        <p className="text-sm font-medium text-gray-900">{title}</p>
        {!!message && <p className="mt-1 text-sm text-gray-500">{message}</p>}
      </div>
      <div className="ml-4 flex flex-shrink-0">
        {!!props.onClose &&
        <button
          type="button"
          onClick={() => {
            if (props.onClose) props.onClose()
          }}
          className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        >
          <span className="sr-only">Close</span>
          <XMarkIcon aria-hidden="true" className="h-5 w-5" />
        </button>}
      </div>
    </div>
      </div>
    </div>
  );
}